angular.module('Itao.IndicatorMap').directive('indicatorLegend', ['mapConfig', function (mapConfig) {
  'use strict';

  /**
   * Returns the scale width for a given number of scales
   * @param {Integer} numberOfScales number of scales
   * @returns {number}
   */
  function getScaleWidth(numberOfScales) {
    return (100 / numberOfScales) -2;
  }

  return {
    templateUrl: mapConfig.templateBasePath + 'legend.html',
    restrict: 'E',
    replace: true,
    scope: {
      indicator: '=',
      mapIndicator: '=',
      numberOfScales: '=',
      indicators: '=',
      mode: '='
    },
    link: function (scope) {
      if (scope.indicator && !scope.mapIndicator) {
        scope.precision = scope.precision || 2;
      } else if(scope.mapIndicator && scope.mapIndicator.scales) {
        scope.precision = scope.precision || 2;
      }

      scope.$watch('numberOfScales', function (numberOfScales) {
        if (angular.isNumber(numberOfScales)) {
          scope.scaleWidth = getScaleWidth(numberOfScales + 1);
        }
      });

      scope.$watch('indicators', function (indicators) {
        scope.pointIndicators = [];
        for(var i = 0, length = indicators.length; i < length; i++) {
          if(indicators[i].hasPointData) {
            var activeData = false;
            angular.forEach(indicators[i].availablePoiTypes, function(poiType) {
              if(poiType.active) activeData = true;
            });
            if(activeData) scope.pointIndicators.push(indicators[i]);
          }
        }
      }, true);
    }
  };
}]);
